import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { INVENTORY_TYPE } from 'domains/inventory/constants/inventory-constants'

const propTypes = {
  inventory_type: PropTypes.string
}

const formatInventoryTypeLabel = (inventoryType) => {
  if (!inventoryType) return '-'

  return String(inventoryType)
    .replace(/::/g, ' ')
    .replace(/_/g, ' ')
    .replace(/-/g, ' ')
    .trim()
}

/**
 * To give nice look on Inventory `inventory_type`.
 * It maps `inventory_type` to certain style and pass to `InventoryTypeBadge`.
 * @param {string} inventory_type Inventory Types. available values
 * - `Seller::Product`
 * - `Merchant::Product::Variant`
 */
const InventoryTypeBadge = ({ inventory_type }) => {

  const colorMap = {
    [INVENTORY_TYPE.SELLER_PRODUCT]           : 'primary',
    [INVENTORY_TYPE.MERCHANT_PRODUCT_VARIANT] : 'info',
    BKA                                       : 'primary',
    BKR                                       : 'info',
    BKT                                       : 'success'
  }

  const labelMap = {
    [INVENTORY_TYPE.SELLER_PRODUCT]           : 'Seller Product',
    [INVENTORY_TYPE.MERCHANT_PRODUCT_VARIANT] : 'Merchant Product',
    BKA                                       : 'BKA',
    BKR                                       : 'BKR',
    BKT                                       : 'BKT'
  }

  const color = colorMap[inventory_type] || 'secondary'
  const label = labelMap[inventory_type] || formatInventoryTypeLabel(inventory_type)

  return <StatusBadge color={ color } label={ label } />
}

InventoryTypeBadge.propTypes = propTypes

export default InventoryTypeBadge